import React from "react";
import {message, Modal} from "antd";
import TooltipIcon from "../Boilerplate/TooltipIcon";
import PropTypes from "prop-types";

export class DeleteButton extends React.Component {
  state = { disabled: false };

  constructor(props, context) {
    super(props, context);
    this.type = this.props.type || 'project';
  }

  handleClick = document => {
    if (!this.state.disabled) {
      this.setState({ disabled: true });
      message.info(`Deleting ${this.type} ` + (document.resource.name || document.resource.title || ''));
      this.props.onDelete && this.props.onDelete(document.resource.id);
    }
  };

  confirmDelete = document => {
    Modal.confirm({
      title: `Are you sure you want to delete this ${this.type}?`,
      content: <span>If you delete this {this.type}, it will be immediately removed from the system. This is an irreversible action.</span>,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => this.handleClick(document),
    })
  };

  render() {
    return <a key={this.props.fauxKey} onClick={() => this.confirmDelete(this.props.document)}>
      <TooltipIcon title={this.props.title} type={!this.state.disabled ? this.props.icon : 'loading'}
                   theme={!this.state.disabled ? 'filled' : ''} iconStyle={{fontSize: 22}}/>
    </a>;
  }
}

DeleteButton.propTypes = {
  document: PropTypes.object,
  onDelete: PropTypes.func,
  fauxKey: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/Projects/DeleteButton.js